import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ErrPage = () => {
    const { t } = useTranslation();

  return (
    <div className='h-screen'>
        <div className='mx-auto my-auto flex flex-col justify-center items-center lg:pt-[20%] pt-[80%]'>
        <h1 className='text-[32px] font-primary uppercase tracking-[2px] max-w-[920px] lg:text-[68px] leading-tight mb-6'>
                {t('errMessage')}
              </h1>
              <Link to={'/'}>
              <button className='btn btn-lg btn-primary mx-auto'>
                {t('errBtn')}
              </button>
              </Link>
        
            </div>
    </div>
  )
}

export default ErrPage